import Select from 'react-select';
import { Form } from 'react-bootstrap';

const FormikSelect = ({ name, options, isMulti = false, formik }) => {
  const handleChange = (selectedOption) => {
    formik.setFieldValue(name, selectedOption.value);
  };

  const getSelectedOption = () => {
    if (isMulti) {
      return options.filter(option => (formik.values[name] || []).includes(option.value));
    }
    return options.find(option => option.value === formik.values[name]) || null;
  };

  return (
    <>
      <Select
        isMulti={isMulti}
        name={name}
        options={options}
        value={getSelectedOption()}
        onChange={handleChange}
        onBlur={() => formik.setFieldTouched(name, true)}
      />
      {formik.touched[name] && formik.errors[name] ? (
        <div className="text-danger mt-1">{formik.errors[name]}</div>
      ) : null}
    </>
  );
};

export default FormikSelect;